var map = {
	"./bg2.jpg": "9B8P",
	"./game-img-dg.png": "2HJ5",
	"./game-img-gx.png": "CB2M",
	"./game-img-xzgt.png": "mbyM",
	"./game-img-yybs.png": "SDs/",
	"./h5-bg2.jpg": "LpwM",
	"./page02-banner.jpg": "B6nr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lODR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games ^\.\/.*$
// module id = lODR
// module chunks = 0